import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { skeletonFadeInSx } from 'c1ui/theme/C1Transitions'

export const C1CircularProgressTheme: Components<Theme>['MuiCircularProgress'] = {
    defaultProps: {
        size: '1.5rem',
        'aria-label': 'Loading',
    },
    styleOverrides: {
        root: skeletonFadeInSx,
    },
}
